import { getDetailedErrorMessage } from "../../utils/validation";
export class PersonaGenerateFailed extends Error {
    /**
     * @param apiError: the error received from the API.
     * @param fallbackMessage: the message to use for the error, if the API error does not contain anything relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PersonaGenerateFailed);
        }
        this.name = "PersonaGenerateFailed";
        this.message = `Failed to generate persona. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class PersonasFetchFailed extends Error {
    /**
     * @param apiError: the error received from the API.
     * @param fallbackMessage: the message to use for the error, if the API error does not contain anything relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PersonasFetchFailed);
        }
        this.name = "PersonasFetchFailed";
        this.message = `Failed to fetch persona(s). ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class PersonaCreationFailed extends Error {
    /**
     * @param apiError: the error received from the API.
     * @param fallbackMessage: the message to use for the error, if the API error does not contain anything relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PersonaCreationFailed);
        }
        this.name = "PersonaCreationFailed";
        this.message = `Failed to create persona. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class PersonaUpdateFailed extends Error {
    /**
     * @param apiError: the error received from the API.
     * @param fallbackMessage: the message to use for the error, if the API error does not contain anything relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PersonaUpdateFailed);
        }
        this.name = "PersonaUpdateFailed";
        this.message = `Failed to update persona. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class PersonaGenerationBlocked extends Error {
    constructor(blockedReason) {
        super(`Persona generation blocked: ${blockedReason}`);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PersonaGenerationBlocked);
        }
        this.name = "PersonaGenerationBlocked";
        this.blockedReason = blockedReason;
    }
}
export class PersonaMintIdFailed extends Error {
    constructor(message = "Failed to mint persona ID") {
        super(message);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PersonaMintIdFailed);
        }
        this.name = "PersonaMintIdFailed";
    }
}
//# sourceMappingURL=errors.js.map